/**
 * 一级品类 tab 条(首页 / 搜索)。「全部」(null)+ 各 L1;选中高亮。
 * 由 /guide/categories L1 派生(需真实 id 驱动 categoryL1Id 过滤,非硬编码 label)。
 */
import type { CategoryNode } from '@/api/guide';
import { cn } from '@/lib/cn';

interface CategoryTabsProps {
  categories: CategoryNode[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
}

export function CategoryTabs({ categories, selectedId, onSelect }: CategoryTabsProps) {
  return (
    <div className="row gap-2 wrap mb-8">
      <button
        type="button"
        className={cn('tag', selectedId === null && 'active')}
        style={{ border: 'none' }}
        onClick={() => onSelect(null)}
      >
        全部
      </button>
      {categories.map((c) => (
        <button
          key={c.id}
          type="button"
          className={cn('tag', selectedId === c.id && 'active')}
          style={{ border: 'none' }}
          onClick={() => onSelect(c.id ?? null)}
        >
          {c.name ?? '品类'}
        </button>
      ))}
    </div>
  );
}
